export const SmsSettingsMessages = {
  SMSSettings: {
    SMSLabel: {
      id: 'smsSettings.Label.Sms',
      defaultMessage: 'Send text messages to:',
    },
    phoneLabel: {
      id: 'smsSettings.Label.Phone',
      defaultMessage: 'Mobile Phone',
    },
    phonePlaceHolder: {
      id: 'smsSettings.Phone.Placeholder',
      defaultMessage: 'Mobile Phone',
    },
    mobileCarrierLabel: {
      id: 'smsSettings.Label.MobileCarrier',
      defaultMessage: 'Mobile Carrier',
    },
    mobileCarrierDefaultOption: {
      id: 'smsSettings.MobileCarrier.DefaultOption',
      defaultMessage: 'Select carrier...',
    },
  },
};
